import React from 'react'
import PropTypes from 'prop-types'
import { NavLink as UnstyledNavLink, withRouter } from 'react-router-dom'
import styled from 'styled-components'

const NavLink = styled(UnstyledNavLink)`
  &.active {
    pointer-events: none;
  }
`
const Component = ({ match }) => {
  const currentUrl = `/${match.params.workspaceToken}/settings/surveys/${match.params.surveyId}`
  return (
    <div className="ui fluid four steps" style={{ marginBottom: '2.5rem' }}>
      <NavLink className="step step-build" to={`${currentUrl}/settings/`}>
        <div className="content">
          <div className="title">Build</div>
        </div>
      </NavLink>
      <NavLink className="step step-configure" to={`${currentUrl}/configure/`}>
        <div className="content">
          <div className="title">Configure</div>
        </div>
      </NavLink>
      <NavLink className="step step-publish" to={`${currentUrl}/publish/`}>
        <div className="content">
          <div className="title">Publish</div>
        </div>
      </NavLink>
    </div>
  )
}

Component.propTypes = {
  match: PropTypes.object.isRequired,
}

export const Steps = withRouter(Component)



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/Steps.js